export const sports_articles = [
    {
        image_url: "https://www.columbiaspectator.com/resizer/v2/J7WKDYDVYNGEPH2N4GJ7HYYUTE.JPG?auth=364065e87fb57a1a8f88d5e09429c8bdce17695310b11ee59d46b55d77d61b36",
        article_title: "Beyond basketball: George Gregory Jr., CC ’31, and his fight for civil rights",
        article_authors: "Andrew Vincenti, Kaya Quebada",
        article_link: "https://www.columbiaspectator.com/sports/2025/02/11/beyond-basketball-george-gregory-jr-cc-31-and-his-fight-for-civil-rights/"
    },
    {
        image_url: "https://cloudfront-us-east-1.images.arcpublishing.com/spectator/CBIGX7B3JZDRFHN6DA45NX6EWY.jpg",
        article_title: "From walk-on to league champion: Obiora Okeke’s unlikely journey to Ivy League glory",
        article_authors: "Ashley Flores",
        article_link: "https://www.columbiaspectator.com/sports/2025/02/11/from-walk-on-to-league-champion-obiora-okekes-unlikely-journey-to-ivy-league-glory/"
    }
];